/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAiCreditMeterDetailsQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetAiCreditMeterDetailsQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly aiBillingEnforcementDate: c.DateTimeString | null;
    readonly agentUsageDetails: {
      readonly __typename: "AgentUsageDetails";
      readonly orgId: c.OrgId;
      readonly creditTopUpsEnabled: boolean;
      readonly totalWorkspaceCreditPool: number;
      readonly workspaceCreditsUsed: number;
      readonly creditSpendLimitCents: number | null;
      readonly creditResetDate: c.DateTimeString;
    };
  };
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly aiUsageLimitDetails: {
      readonly __typename: "UserAiUsageLimitDetails";
      readonly userId: c.UserId;
      readonly totalUserCreditsAvailable: number | null;
      readonly totalUserCreditsUsed: number;
    } | null;
  } | null;
};

export const GetAiCreditMeterDetailsDocument = /*#__PURE__*/ gql`
  query GetAiCreditMeterDetails($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      aiBillingEnforcementDate
      agentUsageDetails {
        orgId
        creditTopUpsEnabled
        totalWorkspaceCreditPool
        workspaceCreditsUsed
        creditSpendLimitCents
        creditResetDate
      }
    }
    me {
      id
      aiUsageLimitDetails {
        userId
        totalUserCreditsAvailable
        totalUserCreditsUsed
      }
    }
  }
`;

/**
 * __useGetAiCreditMeterDetailsQuery__
 *
 * To run a query within a React component, call `useGetAiCreditMeterDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAiCreditMeterDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAiCreditMeterDetailsQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetAiCreditMeterDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  > &
    (
      | { variables: GetAiCreditMeterDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  >(GetAiCreditMeterDetailsDocument, options);
}
export function useGetAiCreditMeterDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  >(GetAiCreditMeterDetailsDocument, options);
}
export function useGetAiCreditMeterDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAiCreditMeterDetailsQuery,
    GetAiCreditMeterDetailsQueryVariables
  >(GetAiCreditMeterDetailsDocument, options);
}
export type GetAiCreditMeterDetailsQueryHookResult = ReturnType<
  typeof useGetAiCreditMeterDetailsQuery
>;
export type GetAiCreditMeterDetailsLazyQueryHookResult = ReturnType<
  typeof useGetAiCreditMeterDetailsLazyQuery
>;
export type GetAiCreditMeterDetailsSuspenseQueryHookResult = ReturnType<
  typeof useGetAiCreditMeterDetailsSuspenseQuery
>;
export type GetAiCreditMeterDetailsQueryResult = Apollo.QueryResult<
  GetAiCreditMeterDetailsQuery,
  GetAiCreditMeterDetailsQueryVariables
>;
